"use strict";
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require("../internals/typed-array-constructors-require-wrappers");
var exportTypedArrayStaticMethod = require("../internals/array-buffer-view-core").exportTypedArrayStaticMethod;
var typedArrayFrom = require("../internals/typed-array-from");
exportTypedArrayStaticMethod("from", typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
